import { ChevronLeft, Users, Activity, Power, Trash2, Search, User } from 'lucide-react';

const AdminTeamMembersSection = ({
  adminUser,
  users,
  setActiveSection,
  setSelectedTeamMember,
  setSelectedTeamMemberParent
}) => {
  if (!adminUser) {
    return (
      <div className="sa-section fade-in">
        <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--text-muted)' }}>
          No admin selected.
          <button className="sa-action-btn" style={{ margin: '1rem auto' }} onClick={() => setActiveSection('users')}>Back to Users</button>
        </div>
      </div>
    );
  }

  // Find all team members belonging to this admin
  const teamMembers = users.filter(
    (u) => 
      u.createdBy === adminUser.username || 
      u.owner === adminUser.username || 
      u.parentAdmin === adminUser.username ||
      (u.role === 'developer' && u.email?.endsWith(`@${adminUser.username.split('@')[1]}`))
  );

  return (
    <div className="sa-section fade-in">
      <div className="sa-section-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <button className="sa-action-btn" style={{ margin: 0, color: 'var(--text-main)', borderColor: 'var(--border)' }} onClick={() => setActiveSection('users')}>
            <ChevronLeft size={20} />
          </button>
          <div>
            <h2 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
              <Users size={24} color="var(--primary)" />
              Team Members for {adminUser.username}
            </h2>
            <p className="subtitle">All sub-users and developers managed by this admin.</p>
          </div>
        </div>
      </div>

      <div className="sa-table-wrapper">
        {teamMembers.length === 0 ? (
          <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--text-muted)' }}>
            This admin has not created any team members yet.
          </div>
        ) : (
          <table className="sa-table">
            <thead>
              <tr>
                <th>User</th>
                <th>Role</th>
                <th>Status</th>
                <th>Last Login</th>
                <th style={{ textAlign: 'right' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {teamMembers.map(member => {
                const status = member.isActive === false ? 'suspended' : 'active';
                const lastLogin = member.lastLogin ? new Date(member.lastLogin).toLocaleString() : 'Never logged in';

                return (
                  <tr key={member.username}>
                    <td>
                      <div className="sa-cell-with-icon">
                        <div className="sa-org-avatar" style={{ background: 'linear-gradient(135deg, #10b981, #059669)' }}>
                          {member.username.substring(0, 2).toUpperCase()}
                        </div>
                        <div>
                          <div className="sa-cell-bold">{member.username}</div>
                          <div className="sa-cell-muted">{member.email || 'No email'}</div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span className="sa-role-badge sa-badge-dev">{member.role || 'Developer'}</span>
                    </td>
                    <td>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                        <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: status === 'active' ? '#22c55e' : '#ef4444', boxShadow: status === 'active' ? '0 0 8px rgba(34, 197, 94, 0.5)' : 'none' }}></div>
                        <span style={{ color: 'var(--text-main)', fontSize: '0.8rem', textTransform: 'capitalize', fontWeight: 500 }}>{status}</span>
                      </div>
                    </td>
                    <td className="sa-cell-muted" style={{ fontWeight: 500 }}>{lastLogin}</td>
                    <td className="sa-actions-cell" style={{ display: 'flex', gap: '0.4rem', justifyContent: 'flex-end', alignItems: 'center' }}>
                      <button 
                        className="sa-action-btn sa-action-allocations" 
                        onClick={() => {
                          setSelectedTeamMember(member);
                          setSelectedTeamMemberParent(adminUser);
                          setActiveSection('team_member_details');
                        }}
                        title="View Team Member Details"
                      >
                        <User size={13} />
                        <span>View Details</span>
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminTeamMembersSection;
